import { Dispatch, Reducer } from "react";
import { Category, RecommendedItem } from "./components/Category/contracts";
import bindActions from "./utility/bindActions";

// actions
const fetching = "fetching";
const fetched = "fetched";

type State = {
  loading: boolean;
  categories: Category[];
};

export const initialState: State = {
  loading: true,
  categories: [],
};

// reducer
type Action = { type: string; payload?: unknown };
export const reducer: Reducer<State, Action> = (state, { type, payload }) =>
  ({
    [fetching]: {
      ...state,
      loading: true,
      categories: Array.from({ length: 4 }, () => ({
        categoryName: "",
        items: Array.from({ length: 4 }, () => ({ itemNumber: "" })),
      })),
    },
    [fetched]: { ...state, loading: false },
  })[type] || state;

// thunks
const fetchRecommendations = (dispatch: Dispatch<Action>) => async () => {
  dispatch({ type: fetching });

  return new Promise(() => {
    // I don't want this to finish until we have a real implementation
  });
};

export interface PersonalizedProductRecommendationActions {
  fetchRecommendations: ReturnType<typeof fetchRecommendations>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const withActions = bindActions<
  State,
  Action,
  PersonalizedProductRecommendationActions
>(
  (dispatch) =>
    ({
      fetchRecommendations: fetchRecommendations(dispatch),
    }) as const,
);
